import React, { useState, useCallback } from 'react';
import BudgetOneriTable from '../components/budgetOneriTable';
import BudgetSpeseTecnicheTable from '../components/budgetSpeseTecnicheTable';
import BudgetCostoDiCostruzioneTable from "../components/budgetCostoDiCostruzioneTable";
import BudgetCostoAmministrazioneTable from '../components/budgetCostoAmministrazioneTable';
import BudgetMutuoBancaTable from '../components/budgetMutuoBancaTable';
import { useParams } from 'react-router-dom';
import { getRiepilogo } from '../services/budgetService';
import { getTotaliVendite } from '../services/venditeService';
// import { getRiepilogo, saveRiepilogo } from '../services/budgetService';
import RiepilogoTabella from '../components/RiepilogoTabella';


const tabs = [
  'Riepilogo',
  'Oneri urbanizzazione',
  'Spese tecniche',
  'Costo di costruzione',
  'Costi amministrazione',
  'Mutuo banca'
];

const Budget = () => {
  const [activeTab, setActiveTab] = useState(tabs[0]);
  const [riepilogoEsistente, setRiepilogoEsistente] = useState(false);
  const [totaleSpeseTecniche, setTotaleSpeseTecniche] = useState(0);
  const [totaleCostoDiCostruzione, setTotaleCostoDiCostruzione] = useState(0);
  const [totaleRealizzoAlloggio, setTotaleRealizzoAlloggio] = useState(0);
  const [totaleRealizzoBox, setTotaleRealizzoBox] = useState(0);


  const { id } = useParams();
  const [cantiereId, setCantiereId] = useState(null);

  // Callback ricevuta dal figlio
  const handleTotaleCalcolato = (valore) => {
    setTotaleSpeseTecniche(valore); // ✅ aggiorna lo stato SOLO qui
  };

  const handleTotaleCostoCostruzioneCalcolato = (valore) => {
    setTotaleCostoDiCostruzione(valore);
  }

  React.useEffect(() => {
    if (!id) return;
    setCantiereId(id);
  }, [id]);

  const fetchRiepilogo = useCallback(async () => {
    if (!cantiereId) return;
    try {
      const response = await getRiepilogo(cantiereId);
      console.log("📦 Dati riepilogo ricevuti:", response);
      if (response.success && response.data) {
        setRiepilogoEsistente(response.data);
      }
    } catch (error) {
      console.error("Errore nel caricamento del riepilogo:", error);
    }
  }, [cantiereId]);

  React.useEffect(() => {
    if (!cantiereId) return;

    const fetchTotaliVendite = async () => {
      try {
        const res = await getTotaliVendite(cantiereId);
        if (res.success) {
          setTotaleRealizzoAlloggio(res.data.realizzo_alloggio || 0);
          setTotaleRealizzoBox(res.data.realizzo_box || 0);
        }
      } catch (err) {
        console.error("Errore nel recupero totali vendite:", err);
      }
    };

    fetchRiepilogo();
    fetchTotaliVendite();
  }, [cantiereId, fetchRiepilogo]);

  return (
    <div className="container mt-4">
      <h2 className="mb-4">Gestione Budget</h2>

      {/* Tabs */}
      <ul className="nav nav-tabs mb-3 flex-wrap">
        {tabs.map((tab) => (
          <li className="nav-item" key={tab}>
            <button
              className={`nav-link ${activeTab === tab ? 'active' : ''}`}
              onClick={() => setActiveTab(tab)}
            >
              {tab}
            </button>
          </li>
        ))}
      </ul>

      {/* Tab Content */}
      <div className="tab-content border rounded p-4 bg-white shadow-sm">
        {tabs.map((tab) => (
          <div
            key={tab}
            className={`tab-pane fade ${activeTab === tab ? 'show active' : ''}`}
          >
            <h5 className="mb-3">{tab}</h5>
            {tab === 'Riepilogo' && (
              <div className="container-fluid">
                <RiepilogoTabella
                  totaleSpeseTecniche={totaleSpeseTecniche}
                  totaleCostoDiCostruzione={totaleCostoDiCostruzione}
                  setRiepilogoEsistente={setRiepilogoEsistente}
                  riepilogoEsistente={riepilogoEsistente}
                  cantiereId={cantiereId}
                  totaleRealizzoAlloggio={totaleRealizzoAlloggio}
                  totaleRealizzoBox={totaleRealizzoBox}
                />
              </div>
            )}
            {tab === 'Oneri urbanizzazione' && (
              <div className="container-fluid">
                {cantiereId ? (
                  <BudgetOneriTable cantiereId={cantiereId} data={riepilogoEsistente} />
                ) : (
                  <p>Caricamento in corso...</p>
                )}
              </div>
            )}
            {tab === 'Spese tecniche' && (
              <div className="container-fluid">
                {cantiereId ? (
                  <BudgetSpeseTecnicheTable
                    cantiereId={cantiereId}
                    onTotaleCalcolato={handleTotaleCalcolato}
                  />
                ) : (
                  <p>Caricamento in corso...</p>
                )}
              </div>
            )}
            {tab === 'Costo di costruzione' && (
                <div className="container-fluid">
                  {cantiereId ? (
                      <BudgetCostoDiCostruzioneTable
                          cantiereId={cantiereId}
                          onTotaleCalcolato={handleTotaleCostoCostruzioneCalcolato}
                      />
                  ) : (
                      <p>Caricamento in corso...</p>
                  )}
                </div>
            )}
            {tab === 'Costi amministrazione' && (
              <div className="container-fluid">
                {cantiereId ? (
                  <BudgetCostoAmministrazioneTable
                    cantiereId={cantiereId}
                    totaleRealizzoAlloggio={totaleRealizzoAlloggio}
                    totaleRealizzoBox={totaleRealizzoBox}
                  />
                ) : (
                  <p>Caricamento in corso...</p>
                )}
              </div>
            )}
              {tab === 'Mutuo banca' && (
              <div className="container-fluid">
                {cantiereId ? (
                  <BudgetMutuoBancaTable cantiereId={cantiereId} onMutuoUpdated={fetchRiepilogo} />
                ) : (
                  <p>Caricamento in corso...</p>
                )}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Budget;
